<template>
  <div class="home-clubs" :class="{ 'camping-clubs': isCamping }">
    <div class="container">
      <div class="hclubs-inner">
        <h2 class="relative-section text-center section-title font-balo font-bold">
          <img src="../assets/images/campings_clubs.png" alt />
          <span v-html="landingPage.hcam_subtitle"></span>
          <b v-html="landingPage.hcam_title"></b>
        </h2>
        <div class="row justify-content-center">
          <div
            class="col-md-6"
            v-for="(item, index) in clubs"
            :key="index"
            :class="{'mb-30': clubs.length > 2}"
          >
            <div
              class="club-item relative-section"
              :style="{
                                'background-image': `url(${
                                    item.image
                                        ? item.image
                                        : '../assets/images/club1.jpg'
                                })`
                            }"
            >
              <div class="text-center info font-bai">
                <h3 class="font-balo font-bold">
                  <router-link :to="`/camping/${item.id}`" v-html="item.title"></router-link>
                </h3>
                <p v-html="item.excerpt"></p>
                <router-link
                  :to="`/camping/${item.id}`"
                  class="btn font-bold font-balo"
                >{{ $t("app.en savoir plus") }}</router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { get, filter, find } from "lodash";
export default {
  name: "Clubs",
  props: ["isCamping"],
  data() {
    return {
      clubs: []
    };
  },
  computed: {
    ...mapState({
      landingPage: state => get(state, "app.landingPage"),
      campingClubs: state => get(state, "campingClubs.list", []),
      campingClub: state => get(state, "campingClubs.detail", {})
    })
  },
  mounted() {
    this.clubs = this.getClubs();
  },
  methods: {
    getClubs() {
      if (this.isCamping) {
        return filter(
          this.campingClubs,
          item => item.id !== this.campingClub.id
        ).map(item => ({
          id: item.id,
          title: item.title.rendered,
          image: item.acf.cam_banner,
          excerpt: item.excerpt.rendered
        }));
      }
      return filter(this.landingPage.hcam_list, item => {
        return find(this.campingClubs, camping => camping.id == item.ID);
      }).map(item => {
        const campingData = find(
          this.campingClubs,
          camping => camping.id == item.ID
        );
        return {
          id: campingData.id,
          title: campingData.title.rendered,
          image: campingData.acf.cam_banner,
          excerpt: campingData.excerpt.rendered
        };
      });
    }
  },
  watch: {
    isCamping: function() {
      this.clubs = this.getClubs();
    },
    campingClub: function() {
      this.clubs = this.getClubs();
    }
  }
};
</script>
